import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Progress {
  [key: string]: {
    completed: boolean;
    lastVisited: string;
    timeSpent: number;
  };
}

interface ProgressState {
  progress: Progress;
  markCompleted: (sectionId: string) => void;
  updateTimeSpent: (sectionId: string, time: number) => void;
  getProgress: (sectionId: string) => number;
}

export const useProgress = create<ProgressState>()(
  persist(
    (set, get) => ({
      progress: {},
      markCompleted: (sectionId) =>
        set((state) => ({
          progress: {
            ...state.progress,
            [sectionId]: {
              ...state.progress[sectionId],
              completed: true,
              lastVisited: new Date().toISOString(),
            },
          },
        })),
      updateTimeSpent: (sectionId, time) =>
        set((state) => ({
          progress: {
            ...state.progress,
            [sectionId]: {
              ...state.progress[sectionId],
              timeSpent: (state.progress[sectionId]?.timeSpent || 0) + time,
              lastVisited: new Date().toISOString(),
            },
          },
        })),
      getProgress: (sectionId) => {
        const state = get();
        return state.progress[sectionId]?.completed ? 100 : 0;
      },
    }),
    {
      name: 'user-progress',
    }
  )
);